import React from 'react';

import { styled } from 'core/styles';

import { AreaSize } from '../types';

export function AreaIcon({ icons, size }: { icons: JSX.Element[]; size: AreaSize }) {
  return <IconContainer size={size}>{icons}</IconContainer>;
}

const IconContainer = styled('div', {
  shouldForwardProp: prop => !['size'].includes(String(prop)),
})<{
  size: AreaSize;
}>(({ size }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontSize: {
    'extra-large': 32,
    large: 24,
    medium: 24,
    small: 20,
    'extra-small': 20,
    hidden: 20,
  }[size],
}));
